const firebaseConfig = {
    apiKey: "AIzaSyCL38T3Wi3bPpE6sVnfPVJ6Ci5jfxwyvLU",
    authDomain: "bikecity-2a1fc.firebaseapp.com",
    projectId: "bikecity-2a1fc",
    storageBucket: "bikecity-2a1fc.appspot.com",
    messagingSenderId: "722022193029",
    appId: "1:722022193029:web:7ce6d68e8afdfd53b056ec"
  };
  export default firebaseConfig;